import { Link } from "react-router";

export function Footer() {
  return (
    <footer className="border-t-4 border-black">
      <div className="container px-4 py-12">
        <div className="mb-4">
          <Link to="/" className="font-bold text-2xl">
            <span>Worksheep</span>
          </Link>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <p>
              &copy; {new Date().getFullYear()} Worksheep. All rights reserved.
            </p>
          </div>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-gray-600 hover:underline">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-600 hover:underline">
              Terms and Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
